module.exports = __webpack_public_path__ + "img/cabbage-posterized-medium-bravo.70efbf2e.png";